<template>
  <div class="pop">
    <div class="pop-container pay-result-container">
      <div class="pop-container-title">
        <div class="title-wrap">
          <div class="title-icon"></div>
          <span class="title-text">{{ $t("paygame.orderPay") }}</span>
        </div>
        <div class="pop-close" @click="rePay"></div>
      </div>
      <div class="box box1">
        <div class="box-title">
          <div class="icon"></div>
          <span>{{ $t("paygame.payTip5") }}</span>
        </div>
        <p class="box-desc">
          {{ $t("paygame.payTip6") }}{{ $t("paygame.payTip7") }}
        </p>
        <div
          class="btn btn-research"
          @click="checkOrder"
          :class="{
            unClick: !this.checkBtn,
          }"
          :ga-data="[!this.checkBtn ? 2705004 : 2705003]"
        >
          <span>{{ btnMsg }}</span>
        </div>
      </div>
      <div class="box box2">
        <div class="box-title">
          <div class="icon"></div>
          <span>{{ $t("paygame.payTip10") }}</span>
        </div>
        <div class="btn btn-research" @click="goRePay" ga-data="2705005">
          <span>{{ $t("paygame.repay") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    btnMsg: {
      type: String,
      default: "",
    },
    checkBtn: {
      type: Boolean,
    },
  },
  methods: {
    checkOrder() {
       this.$emit("checkOrder");
    },
    goRePay() {
      this.$emit("goRePay");
    },
    rePay() {
      this.$emit("rePay");
    },
  },
};
</script>
